export default class VideoDataStore {

  static getStore(videoId) {
    window.VideoDataStores ||= {}
    let store = window.VideoDataStores[videoId]
    if(store) {
      return store
    }

    store = new VideoDataStore()
    window.VideoDataStores[videoId] = store
    return store
  }

  constructor(videoId) {
    this._state = {
      lastWatchedSecond: 0,
      maxWatchedSecond: 0,
      lastActiveSecond: 0,
      attendanceCheckpoints: [],
      limitForward: false
    }
  }

  setFromViewData(viewData) {
    this.setLastWatchedSecond(viewData.last_watched_second)
    this.setMaxWatchedSecond(viewData.max_watched_second)
  }

  setLastWatchedSecond(second) {
    this._state.lastWatchedSecond = Math.trunc(second)
  }

  getLastWatchedSecond() {
    return this._state.lastWatchedSecond
  }

  setMaxWatchedSecond(second) {
    this._state.maxWatchedSecond = second
  }

  getMaxWatchedSecond() {
    return this._state.maxWatchedSecond
  }

  setLastActiveSecond(second) {
    this._state.lastActiveSecond = Math.trunc(second)
  }

  getLastActiveSecond() {
    return this._state.lastActiveSecond
  }

  setAttendanceCheckpoints(checkpoints){
    this._state.attendanceCheckpoints = checkpoints
  }

  getAttendanceCheckpoints() {
    return this._state.attendanceCheckpoints
  }

  setLimitForward(value) {
    this._state.limitForward = value
  }

  getLimitForward(value) {
    return this._state.limitForward
  }
}
